import * as React from "react";
import "./buttonTertiary.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Button label text.
	 */
	label: string;
	/**
	 * On click event handler.
	 * @param {React.MouseEvent<HTMLButtonElement>} evt
	 */
	onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
	/**
	 * Indicates if button should be disabled.
	 */
	disabled?: boolean;
	/**
	 * Indicates if button have to fit his parent.
	 */
	fit?: boolean;
}

export default class ButtonTertiary extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render() {

		const classFromProps = classNames({
			"a-button-tertiary" : true,
			"is-fit" : this.props.fit
		});

		return (
			<button className={classFromProps}
					disabled={this.props.disabled}
					onClick={this.onClick}>
				{this.props.label}
			</button>
		);
	}

	onClick(event: React.MouseEvent<HTMLButtonElement>) {
		if (this.props.onClick && !this.props.disabled) {
			event.stopPropagation();
			this.props.onClick(event);
		}
	}
}
